import { update } from "lodash";
import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getTemplates: builder.query({
      query: () => `production-order-template/list`,
      transformResponse: (response) => response.data,
    }),

    getTemplateDetails: builder.query({
      query: ({id}) => `production-order-template/${id}/get`,
      transformResponse: (response) => response.data,
    }),
    
    getFabricDetailsTemplates: builder.query({
      query: () => `production-order-template/fabric-details`,
      transformResponse: (response) => response.data,
    }),

    getTrimDetailsTemplates: builder.query({
      query: () => `production-order-template/trim-details`,
      transformResponse: (response) => response.data,
    }),

    submitTemplateDetails: builder.mutation({
      query: ({ data }) => ({
        url: `production-order-template`,
        method: "POST",
        body: {
          data,
        },
      }),

      transformResponse: (response) => response.data,
    }),

    updateTemplateDetails: builder.mutation({
      query: ({ id, data }) => ({
        url: `production-order-template/${id}`,
        method: "PUT",
        body: {
          data,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    deleteTemplateDetails: builder.mutation({
      query: ({ id }) => ({
        url: `production-order-template/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.data,
    }),

   
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTemplatesQuery,
  useGetTemplateDetailsQuery,
  useGetFabricDetailsTemplatesQuery,
  useGetTrimDetailsTemplatesQuery,
  useSubmitTemplateDetailsMutation,
  useUpdateTemplateDetailsMutation,
  useDeleteTemplateDetailsMutation,
} = prodOrderApi;
